import script from "./TrocarPlano.vue?vue&type=script&setup=true&lang=js"
export * from "./TrocarPlano.vue?vue&type=script&setup=true&lang=js"

import "./TrocarPlano.vue?vue&type=style&index=0&id=2a6acbab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a6acbab"]])

export default __exports__